import { Component, Input } from '@angular/core';
import { AppliedReportOptions, AppliedReportOptionAssociations } from 'app/core/models/report.model';
import { keyedUserTypeOptions } from 'app/core/options/user-type.opts';

@Component({
  selector: 'app-report-applied-user-type-option',
  templateUrl: './report-applied-user-type-option.component.html'
})
export class ReportAppliedUserTypeOptionComponent {
  @Input() name = 'userType';
  @Input() label = 'User Types';
  @Input() options: AppliedReportOptions;
  @Input() optionAssociations: AppliedReportOptionAssociations;

  keyedUserTypeOptions = keyedUserTypeOptions;

  constructor() {}

  get displayNames() {
    const userTypes = [this.options[this.name]].filter(Boolean).flat();

    if (userTypes && userTypes.length > 0) {
      return userTypes.map(type => {
        const userTypeOption = keyedUserTypeOptions[type];
        return userTypeOption.display;
      });
    } else {
      return [];
    }
  }

  get names() {
    return this.displayNames.join(', ');
  }
}